import React from "react";
import classNames from "classnames";
import { useFormikContext } from "formik";
import { QuestionMarkIcon } from "@whatslly/ui-components/QuestionMarkIcon";
import { Tooltip } from "@whatslly/ui-components/Tooltip";
import { Label } from "@whatslly/ui-components/v2/BaseElements/Label";
import { Switch } from "@whatslly/ui-components/v2/BaseElements/Switch";
import styles from "../../modals/Modals.module.scss";

export const SwitchField: React.FC<{
  label: string;
  testId: string;
  name?: string;
  tooltip?: string;
  disabled?: boolean;
  disabledReason?: string;
  checked?: boolean;
  onChange?: (checked: boolean) => void;
}> = ({ label, testId, name, tooltip, disabled, disabledReason, checked, onChange }) => {
  const { values, setFieldValue } = useFormikContext<Record<string, unknown>>();

  return (
    <div className={classNames(styles.field, styles.fieldSwitch)}>
      <div className={styles.longTranscribeLabel}>
        <Label className={styles.filedLabel} text={label} />
        {tooltip && (
          <Tooltip value={tooltip} lineWrap>
            <span>
              <QuestionMarkIcon />
            </span>
          </Tooltip>
        )}
      </div>
      <Tooltip value={disabledReason} disabled={!disabled || !disabledReason}>
        <div>
          <Switch
            testId={testId}
            disabled={disabled}
            checked={checked ?? Boolean(name && values[name])}
            onChange={(e) => (onChange ? onChange(e.target.checked) : setFieldValue(name!, e.target.checked))}
          />
        </div>
      </Tooltip>
    </div>
  );
};
